import React, { useRef, useState } from "react";
import Component from "../../Components";
import "./NurseRequest.css";

const NurseRequest = () => {
  const topRef = useRef(null);

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="mng-nurse-req">
      <Component.ManageNurseRequest scrollToTop={scrollToTop} />
    </div>
  );
};

export default NurseRequest;
